import template from './jobSimpleEdit.template.html';

export default {
  template,
  bindings: {
    job: '<',
    accounts: '<',
    onChange: '&'
  },
controller: class controller {
    constructor($q, $rootScope, $mdDialog, $stateParams, $mdMedia, dateTimeService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = async () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();

        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();

      dateTimeService.getSet(ctrl, ctrl.job, `absoluteDueDate`, 'getSetAbsoluteDate');
      ctrl.getSetAbsoluteDate(moment.utc(ctrl.job.absoluteDueDate, 'X').format('YYYY-MM-DD'));
      ctrl.onChange();
    };

      ctrl.isAssignedToSelected = (a) =>
        a && a.id && ctrl.job.idAssignedTo && ctrl.job.idAssignedTo === a.id;

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
